// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFallOutlinedSvg from "@fishx/icons-svg/es/asn/PFallOutlined";
import FishxIcon from '../components/FishxIcon';

var PFallOutlined = function PFallOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFallOutlinedSvg
  }));
};

PFallOutlined.displayName = 'PFallOutlined';
export default React.forwardRef(PFallOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFallOutlined.js
// module id = 3376
// module chunks = 0